import { initialValues, initialValuesHistory } from "../../config/validations/approvals";
import { realTimeData } from "../realTimeData/types";
import { ApprovalI,
  ApprovalsStateI,
  DeleteApprovalPayloadI,
  GetApprovalsHistoryI,
  GetApprovalsHistorySuccessI,
  GetApprovalsQueueI,
  GetApprovalsQueueSuccessI,
  LoadMoreHistoryI,
  LoadMoreI,
  SetApprovalI,
  approvalsTypes,
  getApprovalsTypes } from "./approvalsTypes";

export const initialState: ApprovalsStateI = {
  approvalsLoading      : false,
  approvalsError        : "",
  approvals             : [],
  approvalsHistory      : [],
  orders                : [],
  areScoresFixed        : false,
  loadPage              : true,
  loadingLastLoads      : false,
  noMore                : false,
  loadMore              : false,
  filters               : initialValues,
  newOfferLoading       : false,
  newOfferError         : "",
  updateOfferLoading    : false,
  updateOfferError      : "",
  users                 : [],
  locations             : [],
  equipmentTypes        : [],
  carriers              : [],
  loadingDeleteApproval : false,
  updateStatusLoading   : false,
  loadMoreHistory       : false,
  loadPageHistory       : false,
  noMoreHistory         : false,
  filtersHistory        : initialValuesHistory,
  areScoresFixedHistory : false,
};

const ACTION_REDUCER = {
  [approvalsTypes.GET_APPROVALS_QUEUE]: (state: ApprovalsStateI) => ({
    ...state,
    loadMore       : true,
    approvalsError : "",
  }),
  [approvalsTypes.GET_APPROVALS_QUEUE_SUCCESS]: (state: ApprovalsStateI, { payload }: GetApprovalsQueueSuccessI) => {
    const { page } = state.filters;

    const approvals = page !== 1 ? [ ...state.approvals, ...payload ] : [ ...payload ];
    const noMore = payload.length < 20;

    return {
      ...state,
      approvalsError : "",
      approvals,
      loadMore       : false,
      loadPage       : false,
      noMore,
    };
  },
  [approvalsTypes.GET_APPROVALS_QUEUE_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsError : payload,
    loadPage       : false,
    loadMore       : false,
  }),
  [approvalsTypes.SET_FILTERS]: (state: ApprovalsStateI, { payload }: GetApprovalsQueueI) => ({
    ...state,
    filters  : payload,
    loadPage : true,
  }),
  [approvalsTypes.LOAD_MORE]: (state: ApprovalsStateI, { payload }: LoadMoreI) => ({
    ...state,
    filters: {
      ...state.filters,
      page: state?.filters?.page + payload,
    },
    loadMore: true,
  }),
  [approvalsTypes.GET_ORDERS]: (state: ApprovalsStateI) => ({
    ...state,
    approvalsLoading : true,
    approvalsError   : "",
  }),
  [approvalsTypes.GET_ORDERS_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : "",
    orders           : payload,
  }),
  [approvalsTypes.GET_ORDERS_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : payload,
  }),
  [approvalsTypes.FIX_UNFIX_SCORES]: (state: ApprovalsStateI) => ({
    ...state,
    areScoresFixed: !state.areScoresFixed,
  }),
  [approvalsTypes.CREATE_DEDICATED_OFFER]: (state: ApprovalsStateI) => ({
    ...state,
    newOfferLoading : true,
    newOfferError   : "",
  }),
  [approvalsTypes.CREATE_DEDICATED_OFFER_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvals       : [ payload, ...state.approvals ],
    newOfferLoading : false,
    newOfferError   : "",
  }),
  [approvalsTypes.CREATE_DEDICATED_OFFER_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    newOfferLoading : false,
    newOfferError   : payload,
  }),
  [approvalsTypes.CREATE_SINGLE_OFFER]: (state: ApprovalsStateI) => ({
    ...state,
    newOfferLoading : true,
    newOfferError   : "",
  }),
  [approvalsTypes.CREATE_SINGLE_OFFER_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvals       : [ payload, ...state.approvals ],
    newOfferLoading : false,
    newOfferError   : "",
  }),
  [approvalsTypes.CREATE_SINGLE_OFFER_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    newOfferLoading : false,
    newOfferError   : payload,
  }),
  [approvalsTypes.UPDATE_OFFER_QUEUE]: (state: ApprovalsStateI) => ({
    ...state,
    updateOfferLoading : true,
    updateOfferError   : "",
  }),
  [approvalsTypes.UPDATE_OFFER_QUEUE_SUCCESS]: (state: ApprovalsStateI, { payload }: any) => {
    const indexed = [ ...state.approvals ].findIndex((approval: ApprovalI) => approval.approval_id == payload.approval_id);
    const newApprovals = [ ...state.approvals ];

    newApprovals[indexed] = payload;

    return {
      ...state,
      approvals          : newApprovals,
      updateOfferLoading : false,
      updateOfferError   : "",
    };
  },
  [approvalsTypes.UPDATE_OFFER_QUEUE_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    updateOfferLoading : false,
    updateOfferError   : payload,
  }),
  [approvalsTypes.GET_USERS]: (state: ApprovalsStateI) => ({
    ...state,
    approvalsLoading : true,
    approvalsError   : "",
  }),
  [approvalsTypes.GET_USERS_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : "",
    users            : payload,
  }),
  [approvalsTypes.GET_USERS_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : payload,
  }),
  [approvalsTypes.GET_LOCATIONS]: (state: ApprovalsStateI) => ({
    ...state,
    approvalsLoading : true,
    approvalsError   : "",
  }),
  [approvalsTypes.GET_LOCATIONS_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : "",
    locations        : payload,
  }),
  [approvalsTypes.GET_LOCATIONS_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : payload,
  }),
  [approvalsTypes.GET_EQUIPMENT_TYPES]: (state: ApprovalsStateI) => ({
    ...state,
    approvalsLoading : true,
    approvalsError   : "",
  }),
  [approvalsTypes.GET_EQUIPMENT_TYPES_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : "",
    equipmentTypes   : payload,
  }),
  [approvalsTypes.GET_EQUIPMENT_TYPES_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : payload,
  }),
  [approvalsTypes.GET_CARRIERS]: (state: ApprovalsStateI) => ({
    ...state,
    approvalsLoading : true,
    approvalsError   : "",
  }),
  [approvalsTypes.GET_CARRIERS_SUCCESS]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : "",
    carriers         : payload,
  }),
  [approvalsTypes.GET_CARRIERS_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsLoading : false,
    approvalsError   : payload,
  }),
  [approvalsTypes.DELETE_APPROVAL_QUEUE]: (state: ApprovalsStateI) => ({
    ...state,
    loadingDeleteApproval: true,
  }),
  [approvalsTypes.DELETE_APPROVAL_QUEUE_SUCCESS]: (
    state: ApprovalsStateI,
    { payload }: { payload: DeleteApprovalPayloadI },
  ) => {
    const approvals = [ ...state.approvals.filter((app: ApprovalI) => app.approval_id !== payload?.approval_id) ];

    return {
      ...state,
      loadingDeleteApproval: false,
      approvals,
    };
  },
  [approvalsTypes.DELETE_APPROVAL_QUEUE_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    loadingDeleteApproval : false,
    approvalsError        : payload,
  }),
  [approvalsTypes.UPDATE_STATUS_QUEUE]: (state: ApprovalsStateI) => ({
    ...state,
    updateStatusLoading: true,
  }),
  [approvalsTypes.UPDATE_STATUS_QUEUE_SUCCESS]: (state: ApprovalsStateI, { payload }: SetApprovalI) => {
    const filteredApprovals = [ ...state.approvals.filter((app: ApprovalI) => app.approval_id !== payload?.approval_id) ];

    return {
      ...state,
      approvals           : filteredApprovals,
      updateStatusLoading : false,
    };
  },
  [approvalsTypes.UPDATE_STATUS_QUEUE_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsError      : payload,
    updateStatusLoading : false,
  }),
  [approvalsTypes.GET_APPROVALS_HISTORY]: (state: ApprovalsStateI) => ({
    ...state,
    loadMoreHistory : true,
    approvalsError  : "",
  }),
  [approvalsTypes.GET_APPROVALS_HISTORY_SUCCESS]: (
    state: ApprovalsStateI,
    { payload }: GetApprovalsHistorySuccessI,
  ) => {
    const { page } = state.filtersHistory;

    const approvals = page !== 1 ? [ ...state.approvalsHistory, ...payload ] : [ ...payload ];
    const noMore = payload.length < 20;

    return {
      ...state,
      approvalsError   : "",
      approvalsHistory : approvals,
      loadMoreHistory  : false,
      loadPageHistory  : false,
      noMoreHistory    : noMore,
    };
  },
  [approvalsTypes.GET_APPROVALS_HISTORY_FAILURE]: (state: ApprovalsStateI, { payload }: getApprovalsTypes) => ({
    ...state,
    approvalsError  : payload,
    loadPageHistory : false,
    loadMoreHistory : false,
  }),
  [approvalsTypes.SET_FILTERS_HISTORY]: (state: ApprovalsStateI, { payload }: GetApprovalsHistoryI) => ({
    ...state,
    filtersHistory  : payload,
    noMoreHistory   : payload?.ignore_default_time_filter ? false : state.noMore,
    loadPageHistory : true,
  }),
  [approvalsTypes.FIX_UNFIX_SCORES_HISTORY]: (state: ApprovalsStateI) => ({
    ...state,
    areScoresFixedHistory: !state.areScoresFixedHistory,
  }),
  [approvalsTypes.LOAD_MORE_HISTORY]: (state: ApprovalsStateI, { payload }: LoadMoreHistoryI) => ({
    ...state,
    filtersHistory: {
      ...state.filtersHistory,
      page: state?.filtersHistory?.page + payload,
    },
    loadMoreHistory: true,
  }),

  [approvalsTypes.SHOW_LAST_DATA]: (state: ApprovalsStateI) => ({
    ...state,
    loadMore: true,
  }),
  [approvalsTypes.SHOW_LAST_DATA_SUCCESS]: (
    state: ApprovalsStateI,
    {
      payload,
    }: {
      payload: {
        approvals: Array<ApprovalI>;
        showMessage: boolean;
        section: "queue" | "history";
      };
    },
  ) => {
    const { showMessage = true, approvals: approvalsStack, section } = payload;

    const stackItems = approvalsStack.filter((approval) => approval.section === section);
    const approvalsWithoutStack = (section === "queue" ? state.approvals : state.approvalsHistory)
      .filter((approval) => !stackItems.find((stackApproval) => stackApproval.approval_id === approval.approval_id))
      .map((approval) => ({ ...approval, isLast: false }));

    const newApprovals = [ ...stackItems, ...approvalsWithoutStack ];

    const evalApprovals = section === "queue" ? { approvals: newApprovals } : { approvalsHistory: newApprovals };

    return {
      ...state,
      loadMore: false,
      ...evalApprovals,
      showMessage,
    };
  },
  [approvalsTypes.SHOW_LAST_DATA_FAILURE]: (state: ApprovalsStateI) => ({
    ...state,
    loadMore: false,
  }),
  [realTimeData.REMOVE_STACK]: (
    state: ApprovalsStateI,
    { payload }: { payload: { approval: { approval_id: number } } },
  ) => {
    const updatedApprovals = state.approvals.filter(
      (approval) => approval.approval_id !== payload?.approval?.approval_id,
    );

    return {
      ...state,
      approvals: updatedApprovals,
    };
  },
};

const reducer = (state: ApprovalsStateI = initialState, action: any) => {
  const actionReducer = ACTION_REDUCER[action.type];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore

  return actionReducer ? actionReducer(state, action) : state;
};

export default reducer;
